import {
	actualSite,
	BRAND_NAMES,
} from "@/app/utils/utils";
import { FOOTER_SOCIAL_MEDIA } from "@/app/utils/socialMedia";
import React from "react";
import Footer from "./Footer";
import Header from "../LayoutComponents/Footer/Header";
import styles from "@/styles/desktop/FooterMoveBrasil.module.scss";
import Defesas from "./Defesas";

const { siteDefaultName } = actualSite();

export const FooterMB: React.FC = () => {
	const currentYear = new Date().getFullYear();
	return (
		<div className={styles.footerContainerMoveBrasil}>
			<Header
				logoSrc="https://cdn.builder.io/api/v1/image/assets/TEMP/3efe153f24f066d7b20f980a4a8a805ba5d8662f9bd2a50de5bd917bb214d9ac?apiKey=eac21aa640a54d679c8b4aff1d0cf286&"
				brandName={siteDefaultName}
				socialMedia={[...FOOTER_SOCIAL_MEDIA]}
			/>
			<Footer
				logoSrc="https://sablobsitestoyotaprd.blob.core.windows.net/images/SVG/logo_aguia_branca.svg"
				companyInfo="Divisão Comércio GAB – CNPJ 00.827.783/0001-81"
				copyrightInfo={`Grupo Águia Branca ©${currentYear} | Todos os direitos reservados`}
				safetyLogoSrc="https://sablobsitestoyotaprd.blob.core.windows.net/images/SVG/ibama.svg.svg"
				safetyText="Desacelere. Seu bem maior é a vida."
			/>
			<div className={styles.footerLinks}></div>
			<Defesas />
		</div>
	);
};
